export default function EndSponsoringFutureReserves(props) {
  return null;
}
